<div class="row" style="min-height: 300px;" xmlns="http://www.w3.org/1999/html">
  <div class="col-12">
    <div class="tablewrap">
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{ 'lang.globals.countVisitors' | translate }}</p>
          <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
            <input type="text" class="form-control text-end" placeholder="..." [ngModel]="count"
                   (ngModelChange)="countChange($event)">
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{ 'lang.globals.uniqueVisitors' | translate }}</p>
          <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
            <input type="text" class="form-control text-end" placeholder="..." [ngModel]="unique"
                   (ngModelChange)="uniqueChange($event)">
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bb">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100">{{ 'lang.globals.dwellTime' | translate }}</p>
          <p class="w-100 tr" style="margin: -20px; margin-right: 0;">
            <input type="text" class="form-control text-end" placeholder="..." [ngModel]="dwellTime"
                   (ngModelChange)="dwellTimeChange($event)">
          </p>
        </div>
      </div>
      <div class="d-flex flex-row bbl">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
        </div>
      </div>
      <div class="d-flex flex-row">
        <div
          class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          <p class="w-100 tr"></p>
          <p class="w-100 tr">
            <button class="btn btn-primary mr-2"
                    (click)="ok()">
              {{ 'lang.globals.ok' | translate }}
            </button>
            <button class="btn btn-secondary"
                    (click)="cancel()">
              {{ 'lang.globals.cancel' | translate }}
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
